import { DateInput, IDateFormatProps } from "@blueprintjs/datetime";
import React, { useContext, useEffect, useState } from "react";
import MoneyComponentElement from "../../components/elements/MoneyComponent.Element";
import { DB_REF } from "../../constants/DB";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { Player } from "../../interfaces/Player.Interface";

export default function CollectMoneyComponent() {
  const [date, setDate] = useState(new Date());
  const firebase = useContext(firebaseContext);
  const [players, setPlayers] = useState<Player[]>([]);

  const jsDateFormatter: IDateFormatProps = {
    // note that the native implementation of Date functions differs between browsers
    formatDate: (date) => date.toLocaleDateString(),
    parseDate: (str) => new Date(str),
    placeholder: "M/D/YYYY",
  };

  const onChange = async (date: Date) => {
    setDate(date);
  };

  const getPlayers = async () => {
    try {
      const docs = await firebase
        .firestore()
        .collection(DB_REF.players)
        .where("active", "==", true)
        .get();
      setPlayers([]);
      docs.forEach((ele) => {
        setPlayers((old) => [...old, ele.data() as any]);
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getPlayers();
  }, []);

  const renderPlayers = () => {
    return players.map((ele, index) => {
      return <MoneyComponentElement date={date} key={index} player={ele} />;
    });
  };

  return (
    <div>
      <div
        style={{
          alignItems: "center",
          display: "flex",
          padding: 40,
          flexDirection: "column",
        }}
      >
        <div style={{ padding: 10 }}>Collect Money</div>
        <div style={{ padding: 10 }}>
          <DateInput {...jsDateFormatter} value={date} onChange={onChange} />
        </div>
        <div style={{ width: "100%", marginTop: 20 }}>{renderPlayers()}</div>
      </div>
    </div>
  );
}
